export default __webpack_public_path__ + "static/media/icon_card_design.5fbe3dec.svg";